import FloatSidebar from 'float-sidebar';
import debounce from 'debounce';
import { stickyAddToCartListener } from '@js/pages/product/stickyAddToCart';

import lozad from 'lozad';

import('@js/pages/product/mokka');
import('@js/pages/product/productGallery');

window.addEventListener('productGallery.slide-with-sirv', async () => {
    const { loadSirvScript } = await import('@js/pages/product/module360/module360');

    loadSirvScript();
});

if (document.querySelector('.js-light-gallery')) {
    import(/* webpackChunkName: "fullscreenGallery" */ '@js/utilities/fullscreenGallery');
}

if (!window.IS_MOBILE) {
    const productInfoContainer = document.querySelector('.js-product-info-container');

    if (productInfoContainer) {
        // Wyzerowanie przed pomiarem jest konieczne: bez tego clientWidth zwraca
        // wlasna, przypieta wczesniej szerokosc zamiast szerokosci kolumny rodzica,
        // przez co po zwezeniu okna sidebar rozpychal dokument w poziomie.
        const applyWidth = () => {
            productInfoContainer.style.width = '';
            productInfoContainer.style.width = `${productInfoContainer.clientWidth}px`;
        };

        applyWidth();

        window.addEventListener('resize', debounce(applyWidth));

        productInfoContainer.stickySidebar = new FloatSidebar({
            sidebar: productInfoContainer,
            relative: document.querySelector('.js-product-info-wrapper'),
            topSpacing: 0,
        });
    }
}

// Stary przyklejany pasek (sticky-add-to-cart.twig) - tylko poza nowa karta (window.IS_NEW_PDP)
['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        stickyAddToCartListener();
    });
});

const productScrollToElements = document.querySelectorAll('.js-product-scroll-to');

productScrollToElements.forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();

        const target = document.querySelector(el.dataset.scrollTo);

        if (target) {
            const top = target.offsetTop;

            window.scrollTo({
                top: top - 100,
                behavior: 'smooth',
            });
        }

        // productScrollToElements.forEach((scrollToElement) => {
        //     scrollToElement.classList.remove('active');
        // });

        // el.classList.add('active');
    });
});

// Create intersection observer to track which section is in viewport
const productScrollObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            // Find the nav link that corresponds to this section
            const targetId = entry.target.id;
            const navLink = document.querySelector(
                `.js-product-scroll-to[data-scroll-to="#${targetId}"]`
            );

            if (!navLink) return;

            // Add/remove active class based on intersection
            if (entry.isIntersecting) {
                productScrollToElements.forEach((el) => el.classList.remove('active'));
                navLink.classList.add('active');
            }
        });
    },
    {
        // Start detecting when element is 100px from viewport
        rootMargin: '-100px 0px',
        threshold: 0,
    }
);

// Observe all scroll-to-view sections
document.querySelectorAll('.js-product-scroll-to-view').forEach((section) => {
    if (section.id) {
        productScrollObserver.observe(section);
    }
});

// const productsScrollObserver = lozad('.js-product-scroll-to-view', {
//     loaded: (el) => {
//         console.log({ el });
//         // el.dataset.loaded = false;
//     },
// });

// productsScrollObserver.observe();
